// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3yZLK","modalForm":"UpgradeEpcsModal_modalForm__37x_w","modalFooter":"UpgradeEpcsModal_modalFooter__VN4ct"};